<template>
    <div class="recharge-examine">
        <status-tabs :status.sync="status" :statusList="statusList" :funcName="funcName"></status-tabs>

        <search-tool ref="searchTool" :status="status" :statusList="statusList" :funcName="funcName"
            :searchForm="searchForm" :searchList="searchList" :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields" listName="rechargeExamine" :loading="loading"
            :menuAuth="menuAuth" :inputPlaceholder="inputPlaceholder" :selected="selectList.length"></search-tool>

        <div class="table" :style="{ height: height }">
            <el-table :data="tableData" ref="tableData" height="100%" row-key="id"
                @selection-change="handleSelectionChange" align="left">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="Type" prop="type"></el-table-column>
                <el-table-column label="Remark" prop="desc"></el-table-column>
                <el-table-column label="Amount" prop="money">
                    <template slot-scope="scoped">
                        <p>${{ scoped.row.money }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="Payment Voucher" prop="file">
                    <template slot-scope="scoped">
                        <!-- <i class="voucher el-icon-reading"></i> -->
                        <div class="voucher">
                            <el-image class="voucher-icon" :src="require('@/assets/image/voucher.svg')"
                                :preview-src-list="scoped.row.file.slice(scoped.row.file.lastIndexOf('.'), scoped.row.file.length) != '.pdf' ? Array(scoped.row.file) : none" @click="clickVoucher(scoped.row)">
                                
                            </el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Company" prop="company">
                </el-table-column>
                <el-table-column label="Created On" prop="created_at">
                </el-table-column>
                <el-table-column label="Status" width="140">
                    <template slot-scope="scope">
                        <span class="general-table-tag" :class="[
                            scope.row.status == 0
                                ? 'primary'
                                : scope.row.status == 1
                                    ? 'warning'
                                    : scope.row.status == 2
                                        ? 'success'
                                        : scope.row.status == 5
                                            ? 'info'
                                            : scope.row.status == 99
                                                ? 'danger'
                                                : '',
                        ]">
                            <i class="el-icon-s-help"></i>
                            {{ scope.row.status_name }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="Operation" width="150">
                    <template slot-scope="scope">
                        <operation :scope="scope" @rowDo="rowDo"></operation>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
        </div>
        <pagination :paginationData="paginationData" @paginationChange="paginationChange" :funcName="funcName">
        </pagination>
        <confirm :confirmVisible.sync="confirmVisible" :funcName="funcName" :tableItem.sync="tableItem"></confirm>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import confirm from "./rechargeExamine/confirm.vue";
export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Company",
            searchForm: {},
            searchForm_transfer: {},
            funcName: "rechargeExamine",
            confirmVisible: false,
            selectList: [],
            platform_id: "",
            advanceSearchFields: {
                status: {
                    label: "Status",
                    type: "select",
                    options: [],
                },
            },
        };
    },
    methods: {
        add() {
            this.addVisible = true;
        },
        rechargeExamine(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .rechargeExamine(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            });
                        this.closeDrawer();
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            console.log("row: ", row);
            if (item.status_flag == 1) {
                this.tableItem = row;
                if (item.funcName == "detail") {
                    this.detailVisible = true;
                } else if (item.funcName == "confirm") {
                    this.confirmVisible = true;
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                console.log("item.funcName: ", row);
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname](
                        {},
                        "delete",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                } else if (item.funcName == "reject") {
                    cmofferApi[item.parent_funcname](
                        {
                            money: row.money,
                            remark: row.desc,
                            status: 5,
                        },
                        "post",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                }
            }
        },
        /**
         清空高级搜索
        */
        clean() {
            this.searchForm = {};
            this.searchForm_transfer = {};
        },
        /**
         * 获取 sku组件回传的tags
         */
        getSkuTags(value) {
            this.searchForm.sku_list = value;
        },

        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
        },
        closeTagsAll() {
            this.clean();
        },
        async initialize() {
            await this.rechargeExamine();
        },
        clickVoucher(row){
            row.file.slice(row.file.lastIndexOf('.'), row.file.length) == '.pdf' && window.open(row.file)
        }
    },
    activated() {
        this.initialize();
    },
    components: {
        confirm,
    },
    computed: {},
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (
                        v instanceof Array
                            ? !!v.join("")
                            : !!v && k !== "status"
                    ) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.recharge-examine {
    width: 100%;
    height: 100%;
    background: #fff;

    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 120px);

        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }

        .voucher {
            display: flex;
            align-items: center;

            .voucher-icon {
                font-size: 16px;
                cursor: pointer;
                width: 16px;
                height: 16px;
            }
        }
    }
}
</style>
